import React, { useMemo } from 'react';
import {
	CONTEXT_TOKEN_TYPE_JIRA,
	ISSUE_NAVIGATOR_ACTION_MODULE,
} from '@atlassian/jira-forge-ui-constants/src/constants.tsx';
import {
	isCustomUIExtension,
	isNativeUiExtension,
} from '@atlassian/jira-forge-ui-utils-internal/src/utils/extension/index.tsx';
import type { IssueNavigatorForgeExtension as IssueNavigatorForgeExtensionType } from '@atlassian/jira-forge-issue-navigator-base/src/ui/extension/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { LazyIssueNavigatorForgeExtension } from '@atlassian/jira-forge-issue-navigator-base/src/ui/async/index.tsx';
import type { LazyComponentProps } from '@atlassian/jira-forge-ui-async/src/types.tsx';

export const LazyIssueNavigatorAction = (
	props: LazyComponentProps<typeof IssueNavigatorForgeExtensionType>,
): React.JSX.Element | null => {
	const { extension, extensionData, ...restProps } = props;

	const extensionDataValue = useMemo(
		() => ({
			...extensionData,
			type: ISSUE_NAVIGATOR_ACTION_MODULE,
		}),
		[extensionData],
	);
	const extraProps = useMemo(
		() => ({
			module: ISSUE_NAVIGATOR_ACTION_MODULE,
			extensionData: extensionDataValue,
			extension,
			contextToken: CONTEXT_TOKEN_TYPE_JIRA,
		}),
		[extension, extensionDataValue],
	);
	const bridge = useMemo(() => ({ close: props.onClose }), [props.onClose]);

	if (isNativeUiExtension(extension) || isCustomUIExtension(extension)) {
		return (
			<Placeholder name="issue-navigator-action">
				<LazyIssueNavigatorForgeExtension
					{...restProps}
					{...extraProps}
					bridge={bridge}
					hasModalConsentPrompt
				/>
			</Placeholder>
		);
	}

	return null;
};

export const AsyncIssueNavigatorAction = LazyIssueNavigatorAction;
